import { Link } from "react-router-dom";
import { useState } from "react";
import styles from "./Navbar.module.css";

interface NavbarProps {
  readonly links: Array<{ path: string; name: string }>;
  readonly isLoggedIn: boolean;
  readonly setLoggedIn: (val: boolean) => void;
}

const Navbar = (props: NavbarProps) => {
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);

  const handleLogout = async () => {
    await fetch("/api/session", {
      method: "DELETE",
      credentials: "include",
    });
    props.setLoggedIn(false);
  };

  const handleSignIn = () => {
    globalThis.location.assign(
      `${import.meta.env.VITE_ORCID_OAUTH_ENDPOINT}?client_id=${import.meta.env.VITE_ORCID_OAUTH_CLIENT_ID}&response_type=code&scope=/authenticate%20&redirect_uri=${import.meta.env.VITE_ORCID_OAUTH_SUCCESS_REDIRECT_URI}?origin=/`
    );
  };

  const toggleCollapsibleNav = () => {
    setIsHamburgerOpen(!isHamburgerOpen);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.leftSection}>
        <Link to="/">
          <img
            src="/favicon.ico"
            alt="Coauthor Logo"
            className={styles.navbarIcon}
          />
        </Link>
        {props.links
          .filter((link) => link.name !== "Home")
          .map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={styles.navButton}
              onClick={() => {
                setIsHamburgerOpen(false);
              }}
            >
              {link.name}
            </Link>
          ))}
      </div>
      {/* Hamburger button */}
      <button
        aria-label="Toggle navigation menu"
        className={styles.hamburgerButton}
        type="button"
        onClick={toggleCollapsibleNav}
      >
        <span className={styles.hamburgerLine} />
        <span className={styles.hamburgerLine} />
        <span className={styles.hamburgerLine} />
      </button>
      <div className={styles.rightSection}>
        <a
          href="https://chromewebstore.google.com/detail/coauthor/ahajebjbfifafhoifinahkeifcgfpocl"
          className={styles.downloadButton}
          target="_blank"
          rel="noreferrer"
        >
          Download Extension
        </a>
        <a
          href="#"
          className={styles.signInButton}
          onClick={(e) => {
            e.preventDefault();
            if (props.isLoggedIn) {
              void handleLogout();
            } else {
              handleSignIn();
            }
          }}
        >
          {props.isLoggedIn ? "Sign out" : "Sign in"}
        </a>
      </div>
      {isHamburgerOpen && (
        <div className={styles.collapsibleNavBar}>
          {props.links
            .filter((link) => link.name !== "Home")
            .map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={styles.collapsibleNavBarButton}
                onClick={() => {
                  setIsHamburgerOpen(false);
                }}
              >
                {link.name}
              </Link>
            ))}
          <a
            href="https://chromewebstore.google.com/detail/coauthor/ahajebjbfifafhoifinahkeifcgfpocl"
            className={styles.collapsibleNavBarButton}
            target="_blank"
            rel="noreferrer"
          >
            Download Extension
          </a>
          <a
            href="#"
            className={styles.collapsibleNavBarButton}
            onClick={(e) => {
              e.preventDefault();
              if (props.isLoggedIn) {
                void handleLogout();
              } else {
                handleSignIn();
              }
            }}
          >
            {props.isLoggedIn ? "Sign out" : "Sign in"}
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
